import { Component } from '@angular/core';
import { UserMyRadiant as User, PermitProvider, Me, RepositoryMyRadiant, HelperMyRadiant, NotificationProvider } from '@providers/index';
import { Nav, NavParams, MenuController, Events,NavController,  ViewController, Config, } from 'ionic-angular';

import { TabsPage } from '@pages/dashboard';
import { ProjectDetailPage as ProjectDetailPageMarketing } from '@pages/marketing';
import { ProjectDetailPage } from '@pages/project_mobile';
import { LsAssignmentPage, AssignmentPage, ReviewPage, DetailItemPage as DetailItemPageAsset } from '@pages/asset';
import { AppPresensi } from '@pages/presensi';
import { LoginPageAproval } from '@pages/aproval_erp';

@Component({
  selector: 'page-notifikasi',
  templateUrl: 'page.html'
})
export class NotifikasiPage {
    loading : any;
    data = {
      notif:[],
      modul : [],
    };
    modul_selected = '';
    
    constructor(
      public navCtrl                : NavController,
      public userApi                : User,
      public menuCtrl               : MenuController,
      public nav                    : Nav,
      public navParams              : NavParams,
      public repositoryProvider     : RepositoryMyRadiant,
      public activityProvider       : Me,
      public viewCtrl               : ViewController,
      public events                 : Events,
      public config                 : Config,
      public helper                 : HelperMyRadiant,
      public notificationProvider   : NotificationProvider
      ) {
      this.config.set('backButtonText',"Notification");
      this.getModul();
      
    }

    getModul(){
      this.loading = this.helper.showLoading("Loading Data..");
      this.repositoryProvider.getListModul().subscribe( (resp:any) => {
        this.getNotification();
        try {
          // this.loading.dismiss();
        } catch (error) {
        }
        if('data' in resp){
          this.data.modul = resp.data;
        }
      },(err) => {
        this.helper.presentToast('Error');
        try {
          // this.loading.dismiss();
        } catch (error) {}
      });
    }

    filterNotification(id){
      this.modul_selected = id;
      this.loading = this.helper.showLoading("Loadiing...");
      this.getNotification();
    }

    onClickNotif(notif){
      let arg = JSON.parse(notif.msg_data);
      this.readNotification(notif);
      this.config.set('backButtonText',"");
      if (arg.act == "to_approval_myradiant") {
          this.nav.setRoot(TabsPage, {
              tabIndex: 3
          });
      }
      if(arg.act=="to_detail_project"){
          this.nav.push(ProjectDetailPage,{
              project_id : arg.project_id
          });
      }
      if(arg.act=="to_approval_erp"){
        this.nav.push(LoginPageAproval);
        this.events.publish('modul:aproval_erp');
      }
      if(arg.act=="to_permit_bawahan_myradiant"){
        
        this.nav.setRoot(AppPresensi, {
          tabIndex: 2,
          isNotificationPermit:true,
        });
      }
      if(arg.act=="to_permit_myradiant"){
        
        this.nav.setRoot(AppPresensi, {
          tabIndex: 2,
          isNotificationPermit:false,
        });
      }
      if(arg.act=="to_overtime_bawahan_myradiant"){
        
        this.nav.setRoot(AppPresensi, {
          tabIndex: 3,
          isNotificationOvertime:true,
        });
      }
      if(arg.act=="to_overtime_myradiant"){
        
        this.nav.setRoot(AppPresensi, {
          tabIndex: 3,
          isNotificationPermit:false,
        });
      }
      if(arg.act=="to_detail_asset"){
          this.nav.push(DetailItemPageAsset,{
              id : arg.asset_id
          });
      }
      if(arg.act=="to_list_assignment"){
          this.nav.push(LsAssignmentPage);
      }
      if(arg.act=="to_assignment"){
          this.nav.push(AssignmentPage);
      }
      if(arg.act=="to_asset_review"){
          this.nav.push(ReviewPage);
      }
      if(arg.act=="to_detail_tender"){
          this.nav.push(ProjectDetailPageMarketing,{
              tender_id : arg.tender_id
          });
      }
      if(arg.act == 'to_report_fasker_myradiant'){
        this.nav.push(DetailItemPageAsset,{
          id : arg.asset_id
        });
      }
    }
  
    getNotification(){
      let params_notif = {
        employee_id : this.userApi.data.Employee_ID,
        user_id : this.userApi.data.id, 
        modul_id : this.modul_selected,
      };
      // this.loading = this.helper.showLoading("Loading Data..");
      this.notificationProvider.getNotifUser(params_notif).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
        }
        if('data' in resp){
          this.data.notif = resp.data;
          this.notificationProvider.refreshNotification();
        }
      },(err) => {
        this.helper.presentToast('Error');
        try {
          this.loading.dismiss();
        } catch (error) {}
      }); 
    }

    deleteNotification(item){
      let params = {
          employee_id : this.userApi.data.Employee_ID,
          user_id : this.userApi.data.id,
          notif_id: item.app_notification_id 
      }
      this.loading = this.helper.showLoading("Proces...");
      this.notificationProvider.deleteNotification(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {}
        if (resp.success) {
          this.getNotification();
        }
      },(err) => {
        this.helper.presentToast('Error');
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      });
    }

    readNotification(item){
      let params = {
          employee_id : this.userApi.data.Employee_ID,
          user_id : this.userApi.data.id,
          notif_id: item.app_notification_id 
      }
      // this.loading = this.helper.showLoading("Proces...");
      this.notificationProvider.readNotification(params).subscribe((resp:any) => {
        try {
          // this.loading.dismiss();
        } catch (error) {}
        if (resp.success) {
          this.getNotification();
          this.notificationProvider.refreshNotification();
        }
      },(err) => {
        // this.helper.presentToast('Error');
        // try {
        //   this.loading.dismiss();
        // } catch (error) {
          
        // }
      });
    }

    deleteAllNotification(){
      let me = this;
      let optionsSwal = {
        title:"Delete All ?",
        icon:"",
        dangerMode:false,
        btnCancel:"Cancel",
        btnConfirm:"Delete All",
        desc:"Once you delete notifications,you cant't undo it"
      }
   this.helper.presentSwalConfirmation(optionsSwal,
    (note) => {
      let params = {
        employee_id : this.userApi.data.Employee_ID,
        user_id : this.userApi.data.id,
    }
    this.loading = this.helper.showLoading("Proces...");
      me.notificationProvider.deleteNotification(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
        }
        if (resp.success) {
          me.getNotification();
        }
      },(err) => {
        this.helper.presentToast('Error');
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      });
    },(err) => {
      try {
        me.loading.dismiss();
      } catch (error) {
        
      }
    });
    }

  }
  


// WEBPACK FOOTER //
// ./src/pages/dashboard/notifikasi/page.ts